import styles from './otherScenes.module.css';
import CommonLayout from '../commonLayout/commonLayout';
import DOMPurify from 'dompurify';
const OtherScenes = ({ textData }) => {
  return (
    <div className={styles.ctn}>
      <div className={styles.textBox}>
        <h1
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text22']),
          }}
        ></h1>
        <h5
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text23']),
          }}
        ></h5>
        <h6
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text24']),
          }}
        ></h6>
      </div>

      <CommonLayout
        header={DOMPurify.sanitize(textData['text25'])}
        text={DOMPurify.sanitize(textData['text26'])}
        imgSrc="https://bucket.zhiyun-tech.com/detail/ozone-sterilizer/zhiyunlife-ozone-life-1.jpg"
        direction="reverse"
      />
      <CommonLayout
        header={DOMPurify.sanitize(textData['text27'])}
        text={DOMPurify.sanitize(textData['text28'])}
        imgSrc="https://bucket.zhiyun-tech.com/detail/ozone-sterilizer/zhiyunlife-ozone-life-2.jpg"
      />
      <CommonLayout
        header={DOMPurify.sanitize(textData['text29'])}
        text={DOMPurify.sanitize(textData['text30'])}
        imgSrc="https://bucket.zhiyun-tech.com/detail/ozone-sterilizer/zhiyunlife-ozone-life-3.jpg"
        direction="reverse"
      />
      <CommonLayout
        header={DOMPurify.sanitize(textData['text31'])}
        text={DOMPurify.sanitize(textData['text32'])}
        imgSrc="https://bucket.zhiyun-tech.com/detail/ozone-sterilizer/zhiyunlife-ozone-life-4.jpg"
      />
      <CommonLayout
        header={DOMPurify.sanitize(textData['text33'])}
        text={DOMPurify.sanitize(textData['text34'])}
        imgSrc="https://bucket.zhiyun-tech.com/detail/ozone-sterilizer/zhiyunlife-ozone-life-5.jpg"
        direction="reverse"
      />
    </div>
  );
};

export default OtherScenes;
